import React from 'react';
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'

import config from '../config.js'

import {fetchDataIfReady, fetchDataIfUndefined, clearStateBlock} from 'Skelet/src/modules/fetch.action.js'
import {openModal, closeModal} from 'Skelet/src/modules/functions.js'
import ModalCreateDiary from './ModalCreateDiary.js'
import ModalUpdateDiary from './ModalUpdateDiary.js'


class Diary extends React.Component {

  constructor(props) {
    super(props);
    this.state = {};
  }

  componentWillMount() {
    if(this.props.session_token) {
      this.props.fetchDataIfReady(config.api_token, "diary_list", "GET", config.api_url+"/diary?t="+this.props.session_token);
    }
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.session_token) {
      this.props.fetchDataIfUndefined(config.api_token, "diary_list", "GET", config.api_url+"/diary?t="+nextProps.session_token);
    }
  }

  render() {
    let diary_card = null, diary_data = this.props.apiData["diary_list"];

    let diary_introcard = <div className="card" style={{background:"#15a033",color:"#fff"}}>"Beschrijf hier je nieuwe eetmomenten, wanneer je bent begonnen met een nieuwe sport of een gewoonte, beschrijf je vooruitgang, vul het met van alles waar je op kan terugkijken en wat je vooruit kan helpen. Je kunt jezelf bijvoorbeeld ook aanmoedigen door je toekomst positief en optimistisch te omschrijven."</div>;

    if(diary_data !== undefined) {
      let diaries = [];
      if(diary_data.data[0] !== undefined) {
        diaries = diary_data.data.map(function(item, i) {
          // 1-op-1 van Notes.js
          // dit soort loops/functies/cleaners/decorators ook naar Skelet denk ik.
          let mapped_text = null; // mss een andere naam dan "wrapped", en in de mapper "item" aanpassen. (mss "mapped_description"?)
          if(item.text !== "") {
            mapped_text = item.text.split('\n').map(function(item, key) {
              // item = item.replace(new RegExp(" ", 'g'), String.fromCharCode(160)); // this assures proper rendering of offset spaces.
              let new_item = "", first_nonspace = false;
              for (let i = 0; i < item.length; i++) {
                if(item.charAt(i) === " " && !first_nonspace) {
                  new_item = new_item + String.fromCharCode(160);
                } else {
                  first_nonspace = true;
                  new_item = new_item + item.charAt(i);
                }
              }
              item = new_item;
              return <span key={key}>{item}<br/></span>;
            });
          }
          // 1-op-1 van Notes.js

          return <div key={"1k"+i} style={{marginBottom:"12px"}} onClick={(e) => openModal(this, e, item, "modal_update_diary_open")}>
            <div><small>{item.date}</small></div>
            <div>{mapped_text}</div>
          </div>;
        }.bind(this));
      } else {
        diaries.push(<div key={"2k"}><p style={{opacity:".5"}}>Voeg je eerste dagboek-item toe.</p></div>);
      }

      diary_card = <div className="card">
        <div className="index-actions">
          <button className="btn btn-e btn-fat" onClick={() => openModal(this, null, null, "modal_create_diary_open")}>nieuw</button>
        </div>{diaries}<ModalUpdateDiary shouldShow={this.state.modal_update_diary_open} close={() => closeModal(this, "modal_update_diary_open")} update_data={this.state.modal_content} /><ModalCreateDiary shouldShow={this.state.modal_create_diary_open} close={() => closeModal(this, "modal_create_diary_open")} /></div>;
    }

    return (
      <div className="container" ref={this.setWrapperRef} style={{marginTop:"2em"}}>
        {diary_introcard}
        {diary_card}
      </div>
    );
  }

}


function mapStateToProps(state) {
  let session_token = null;
  if(state.apiData["login"] !== undefined && (state.apiData["login"]["data"]["token"] !== undefined || state.apiData["login"]["data"]["token"] === null)) {
    session_token = state.apiData["login"]["data"]["token"];
  }
  return {
    session_token: session_token,
    apiData: state.apiData,
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    fetchDataIfReady,
    fetchDataIfUndefined,
    clearStateBlock,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Diary)



// WEBPACK FOOTER //
// ./src/containers/Diary.js